import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Vehicle Configuration'}
      url={'vehicle-configuration-master'}
      queryKey="vehicle-configuration-master"
      title={'Vehicle Configuration'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
